import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PLUGIN_MODULE_PERMISSIONS} from '../shared/permissions.constant';
import { faIdBadge } from '@fortawesome/free-solid-svg-icons';
import { MatDialog } from '@angular/material/dialog';
import {
	IAppDashboardMenu,
	IMenuItem,
	IMenuItemPermissions,
	PluginInjectorApplicationPlugin
} from 'core-client/api';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
	private navbarMenuItem!: IMenuItem;
	private readonly pluginModule: string = 'USER_PROFILE';
	private readonly navbarMenuTitle: string = 'USER_PROFILE';
	private menuItemPermissions: IMenuItemPermissions;
	private readonly useExternalLink: boolean = true;

	constructor() {
		this.menuItemPermissions = {
			user_profile: JSON.parse(JSON.stringify(PLUGIN_MODULE_PERMISSIONS.user_profile))
		};
	}

	getNavbarMenuItem(
		pluginConfig: PluginInjectorApplicationPlugin.IApplicationPlugin,
		dashboardMenu: IMenuItem[],
		primaryEnabled: boolean,
		secondaryEnabled: boolean
	): IMenuItem[] {
		const menuItemsPermissionsRefs = this.getMenuItemPermissionRefs();

		this.navbarMenuItem = {
			pluginId: pluginConfig._id,
			pluginName: pluginConfig.name,
			pluginModule: this.pluginModule,
			nameIdentifier: this.navbarMenuTitle,
			accessRights: menuItemsPermissionsRefs,
			primary: {
				enabled: primaryEnabled,
				position: dashboardMenu.length + 1
			},
			secondary: {
				enabled: secondaryEnabled,
				position: dashboardMenu.length + 1
			},
			strictMode: true,
			headerSortOrder: 40,
			icon: faIdBadge,
			dropdown: false,
			useExternalLink: this.useExternalLink,
			disabled: new BehaviorSubject(false),
			callback: async (dialog: MatDialog, id?: string, externalLink?: string) => {
				if (externalLink) {
					window.open(externalLink, '_blank', 'noopener,noreferrer');
				}
			}
		};

		if (!this.doesMenuExists(this.navbarMenuTitle, dashboardMenu)) {
			dashboardMenu.push(this.navbarMenuItem);
		}

		return dashboardMenu;
	}

	private getMenuItemPermissionRefs(): string[] {
		let menuItemsPermissionsRefs: string[] = [];

		for (const menuItemFlag in this.menuItemPermissions) {
			menuItemsPermissionsRefs = Object.keys(this.menuItemPermissions[menuItemFlag]);
		}

		return menuItemsPermissionsRefs;
	}

	getMenuItemPermissions(): IMenuItemPermissions {
		return this.menuItemPermissions;
	}

	private doesMenuExists(menuNameIdentifier: string, dashboardMenu: IAppDashboardMenu[]): boolean {
		return dashboardMenu.some(
			(menuItem: IAppDashboardMenu) =>
				menuItem.nameIdentifier.toLowerCase() === menuNameIdentifier.toLowerCase()
		);
	}
}
